import React from 'react'
import { createUseStyles } from 'react-jss'

const Header = ({ title, body, smallerText, textAlign }) => {
  const useStyles = createUseStyles(theme => ({
    container: {
      padding: '30px 15px',
    },
    innerCont: { margin: '0 auto', width: '100%', maxWidth: '1220px' },
    title: {
      fontSize: '54px',
      lineHeight: '58px',
      fontWeight: 700,
      fontFamily: 'TTRounds',
      textAlign: 'left',
      marginBottom: '20px',
      marginTop: 0,
      color: '#2D2D2D',
      textAlign: textAlign === 'center' ? 'center' : 'left',
      '@media (max-width: 600px)': {
        fontSize: '28px',
        lineHeight: '34px',
        marginBottom: '10px',
      },
    },
    details: {
      fontSize: '26px',
      lineHeight: '30px',
      fontWeight: 400,
      textAlign: 'left',
      marginBottom: '20px',
      marginTop: 0,
      maxWidth: textAlign === 'center' ? 'auto' : '560px',
      color: theme.colors.main,
      textAlign: textAlign === 'center' ? 'center' : 'left',
      '@media (max-width: 600px)': {
        fontSize: 19,
        lineHeight: 1.3,
      },
    },
    titleSmall: {
      fontSize: '54px',
      lineHeight: '58px',
      fontWeight: 700,
      fontFamily: 'TTRounds',
      textAlign: 'left',
      marginBottom: '20px',
      marginTop: 0,
      color: '#2D2D2D',
      textAlign: textAlign === 'center' ? 'center' : 'left',
      '@media (max-width: 600px)': {
        fontSize: '28px',
        lineHeight: '34px',
        marginBottom: '10px',
      },
    },
    detailsSmall: {
      fontSize: '20px',
      lineHeight: '27px',
      fontWeight: 300,
      textAlign: 'left',
      marginBottom: '20px',
      marginTop: 0,
      maxWidth: textAlign === 'center' ? 'auto' : '900px',
      color: '#2D2D2D',
      '@media (max-width: 600px)': {
        fontSize: 19,
        lineHeight: 1.3,
      },
    },
  }))

  const classes = useStyles()

  return (
    <div className={classes.container}>
      <div className={classes.innerCont}>
        {smallerText === '1' ? (
          <>
            {title !== '' && <div className={classes.titleSmall}>{title}</div>}
            {body !== '' && <div className={classes.detailsSmall}>{body}</div>}
          </>
        ) : (
          <>
            {title !== '' && <div className={classes.title}>{title}</div>}
            {body !== '' && <div className={classes.details}>{body}</div>}
          </>
        )}
      </div>
    </div>
  )
}

Header.defaultProps = {}

export default Header
